import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import AboutPreview from './components/AboutPreview';
import ServicesOverview from './components/ServicesOverview';
import ProductsSection from './components/ProductsSection';
import AcademySection from './components/AcademySection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <TrustSection />
      <AboutPreview />
      <ServicesOverview />
      <ProductsSection />
      <AcademySection />
      <TestimonialsSection />
      <CTASection />
    </main>
  );
};

export default HomePage;
